<div class="dasboard-width font-13">
  <div class="row header mar-lft-rgt-0">
    <div class="col-md-4">Access Controllers</div>
    <div class="col-md-4"> {{clientName}}</div>
    <div class="col-md-4">
      <ol class="breadcrumb cust-bread ">
        <li class="breadcrumb-item"><a><i
          class="fa fa-dashboard"></i> Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">Access Controllers</li>
      </ol>
    </div>
  </div>
  <div class="content mr-top-5 ">
    <div class="offset-2 col-md-8 pad-top-16">
      <div class="box-prop pad-15">
        <label class="col-form-label pad-top-0 font-900">Document Id Wise Search : </label>
        <div class="form-group row mar-lft-rgt-0 mar-bot-0">
          <input type="text" class="form-control radius-0 font-13 col-sm-8 form-data"
                 placeholder="Search Within Documents..."
                 [(ngModel)]="textSelected"
                 matInput [formControl]="searchTerm"
                 [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="docSelected()">
            <mat-option *ngIf="isLoading" class="is-loading">
              <mat-spinner diameter="50"></mat-spinner>
            </mat-option>
            <ng-container *ngIf="!isLoading">
              <mat-option *ngFor="let id of docs" [value]="id.docu_id">
                {{ id.docu_id }}
              </mat-option>
            </ng-container>
          </mat-autocomplete>
<!--          &nbsp;&nbsp;<button class="btn btn-success radius-0 col-sm-2 font-13" (click)="documentSearch()">Search-->
<!--        </button>-->
        </div>
      </div>

    </div>
    <div class="row mar-lft-rgt-15 box-prop  mar-top-9 pad-15">
        <div class="col-sm-4 ">
          <mat-checkbox *ngFor="let action of actions;let i=index;" value="{{action.id}}"
                        [(ngModel)]="action.checked"
                        (change)="checkAll($event.checked,i)">{{action.action}}</mat-checkbox>
        </div>
        <div class="col-sm-3 ">
          <div class="form-group">
            <mat-form-field>
              <mat-label>Select Group</mat-label>
              <mat-select multiple [(ngModel)]="supportGroupSelected" (selectionChange)="onGroupChange()">
                <mat-option *ngFor="let group of groups" [value]="group.id"
                            [disabled]="group.isDisabled">{{group.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-3 ">
          <div class="form-group">
            <mat-form-field>
              <mat-label>Select Users</mat-label>
              <mat-select [(ngModel)]="userSelected" (selectionChange)="onUserChange()" multiple>
                <mat-option *ngFor="let user of users" [value]="user.id"
                            [disabled]="user.isDisabled">{{user.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-2 ">
          <div class="form-group">
            <button class="btn btn-primary radius-0 font-13" (click)="addDocu()"> Add</button>
          </div>
        </div>
    </div>
    <div class="row mar-lft-rgt-0 mar-top-9">
      <div class="col-sm-12 pad-top-16 ">
        <div class="box-prop-top grid-pad ">
          <label class="col-form-label pad-top-0 font-900">Search Result : </label>
          <div class="card-body-grid-access">
            <angular-slickgrid gridId="grid"
                               [columnDefinitions]="columnDefinitions"
                               [gridOptions]="gridOptions"
                               (onAngularGridCreated)="angularGridReady($event)"
                               (sgOnClick)="onCellClicked($event.detail.eventData, $event.detail.args)"
                               height="250"
                               [dataset]="dataset">
            </angular-slickgrid>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<notifier-container></notifier-container>
